import { CallMessageRow } from "../../api/call/call.types";
import { MessageRole, MessageRow } from "../../api/message.type";
import AssistantChatItem from "../../components/chat/assistant-chat-item";
import UserChatItem from "../../components/chat/user-chat-item";

function getMessageContent(message: CallMessageRow) {
  if (typeof message.content === "string" && message.content.length > 0) {
    return message.content;
  }
  if (typeof message.text === "string" && message.text.length > 0) {
    return message.text;
  }
  if (typeof message.metadata?.summary === "string") {
    return message.metadata.summary;
  }
  return "Message payload unavailable.";
}

function toChatMessage(message: CallMessageRow): MessageRow {
  const normalizedRole = message.role?.toLowerCase();
  const role =
    normalizedRole === MessageRole.ASSISTANT || normalizedRole === "system"
      ? MessageRole.ASSISTANT
      : MessageRole.USER;
  const createdAt = message.created_at ?? new Date().toISOString();

  return {
    id: message.id,
    content: getMessageContent(message),
    role,
    created_at: createdAt,
    updated_at: createdAt,
    generated_by: null,
    message_file_store: [],
    user_id: null,
    user: {},
    agent_id: null,
    deleted_at: null,
    group_chat_id: null,
    is_deleted: null,
    message_type: null,
    project_id: null,
    reply_to_message_id: null,
    response_id: null,
    run_id: null,
    thread_id: null,
    message_feedback: undefined,
  } as MessageRow;
}

export function CallMessagesList({ items }: { items: CallMessageRow[] }) {
  return (
    <div className="flex flex-col space-y-4 p-4">
      {items.map((item) => {
        const message = toChatMessage(item);
        if (message.role === MessageRole.ASSISTANT) {
          return (
            <div key={message.id}>
              <AssistantChatItem message={message} />
            </div>
          );
        }

        return (
          <div
            key={message.id}
            className="flex flex-row items-center gap-2 justify-end"
          >
            <UserChatItem message={message} align="end" />
          </div>
        );
      })}
    </div>
  );
}
